module.exports = __webpack_public_path__ + "img/Supernal Ventures Logo.bee61fe5.svg";